import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Header,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Button,
    Popup } from 'semantic-ui-react'
import { api } from '../../../services/api';
import moment from 'moment';

import Sidebar from '../../../components/Sidebar';
import Navbarr from '../../../components/Navbar';
import CardTable from '../../../components/CardTable';

import './styles.css';

export default function RoutesList() {
    const history = useHistory();
    const [routeStates, setRouteStates] = useState({
        isLoadingData: true,
        lastUpdate: "",
        reloadControl: false,
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'Id',
                field: 'id',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Lojas',
                field: 'lojasQtd',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Ações',
                field: 'acao',
                sort: 'asc',
                width: 100
            }
        ],
        rows: [],
    });

    const updateRoutesData = () => {
        setRouteStates( state => ({
            ...state,
            reloadControl: !state['reloadControl'],
        }));
    }

    useEffect(() => {
        const goToRouteViewScreen = (e, route, index) => {
            e.preventDefault();
            history.push(`/routes/${route['id']}`, {routeId: route['id']});
        }

        const changeRouteForTable = (route, index) => {
            route['lojasQtd'] = route['lojas'].length;
            route['acao'] = <Popup content='Visualizar'
                trigger={
                    <Button basic size='mini' icon='eye' onClick={(e) => goToRouteViewScreen(e, route, index)} />
                } />

            return route;
        }

        async function fetchRoutes() {
            setRouteStates( state => ({
                ...state,
                isLoadingData: true
            }));
            try {
                let data = await api.getRoutes();
                data.forEach((element, index) => { changeRouteForTable(element, index)});

                setTableData( state => ({
                  ...state,
                  rows: data
                }));

                setRouteStates( state => ({
                    ...state,
                    isLoadingData: false,
                    lastUpdate: moment().format('LT')
                }));
            } catch (err) {
              console.error("Falha ao obter rotas: ", err);
            }
        }

        fetchRoutes();
    },[routeStates.reloadControl, history]);

    return (
        <Container className="r-content">
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"routelist"}></Sidebar>
            </Side>
            <Container>
                <Header>
                    <Navbarr></Navbarr>
                </Header>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <CardTable
                        type={'routes'}
                        data={tableData}
                        tableTitle={"Rotas Cadastradas"}
                        elementsName={"Rotas"}
                        isLoadingData={routeStates['isLoadingData']}
                        lastUpdate={routeStates['lastUpdate']}
                        updateData={updateRoutesData}
                    />
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    )
}
